import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService"; 

class AnalysisService extends AxiosService {
    constructor() {
        super('labs');
    }
  
    getAnalysis = async (page, limit, search = null) => {
        let query;
        if (search) {
            query = `/hl7/find/?page=${page}&limit=${limit}&search=${search}`;
        } else {
            query = `/hl7/find/?page=${page}&limit=${limit}`;
        }
        const response = await this.get(
            query,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
            }
        );
        return response;
    };

}
export default new AnalysisService();
